import { useMutation } from '@tanstack/react-query';
import { UserAPI } from 'api/user';
export const useCreateCustomerApiKey = ()=>{
    return useMutation((p)=>UserAPI.createCustomerAPiKey(p));
};
